import styled from 'styled-components';
import { Button } from '../buttons/Button';
import { Icon } from '../icon/Icon';

interface IEmptyStateProps {
  title: string;
  buttonText: string;
  onClick: () => void;
}

export const EmptyState = ({ title, buttonText, onClick }: IEmptyStateProps) => {
  return (
    <EmptySellMachineContainer>
      <EmptySellMachineBody>
        <Icon name={'BookBox'} width={60} height={61} />
        <EmptySellMachineText>{title}</EmptySellMachineText>
        <Button
          onClick={onClick}
          color={'filledGreyLight'}
          text={{ content: buttonText, size: 'md' }}
          icon={{
            position: 'right',
            size: 'Medium',
            fileName: 'AngleRight',
            fill: '#505363',
          }}
          size={'sm'}
          borderType={'square'}
        />
      </EmptySellMachineBody>
    </EmptySellMachineContainer>
  );
};

const EmptySellMachineContainer = styled.div`
  min-height: calc(100vh - 500px);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 8px;
  flex: 1 0 0;
  align-self: stretch;
`;

const EmptySellMachineBody = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
`;

const EmptySellMachineText = styled.span`
  color: var(--Light-Scheme-Monochrome-offblack, #505363);
  text-align: center;

  /* Body/Medium/m-regular */
  font-family: Pretendard;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%; /* 21px */
`;
